import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { WorkOrderService } from "./work-order.service";
import { CommonResponse } from "@gtpl/shared-models/production-management";
import { WorkOrderDto } from "./dto/work-order.dto";
import { TabNameReq, WorkOrderInfoReq } from "@gtpl/shared-models/raw-material-procurement";

@ApiTags('work-order-generation')
@Controller('work-order-generation')
export class WorkOrderController {
  constructor(
    private workOrderService: WorkOrderService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler
  ) { }

   @Post('/getOpenBaleDetails')
      async getOpenBaleDetails(@Body() req:WorkOrderInfoReq): Promise<CommonResponse> {
        try {
          return await this.workOrderService.getOpenBaleDetails(req);
        } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
      }

  @Post('/createWorkOrder')
  async createWorkOrder(@Body() req: WorkOrderDto): Promise<CommonResponse> {
    try {
      return await this.workOrderService.createWorkOrder(req);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(CommonResponse, err);
    }
  }

      @Post('/getVoucherNumberDropDownInfo')
        async getVoucherNumberDropDownInfo(@Body() req:TabNameReq): Promise<CommonResponse> {
          try {
            return await this.workOrderService.getVoucherNumberDropDownInfo(req);
          } catch (error) {
            console.log(error)
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
          }
      }
  
      @Post('/getAgentDropDownInfo')
        async getAgentDropDownInfo(@Body() req:TabNameReq): Promise<CommonResponse> {
          try {
            return await this.workOrderService.getAgentDropDownInfo(req);
          } catch (error) {
            console.log(error)
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
          }
      }
  
      @Post('/getBaleNumberDropDownInfo')
        async getBaleNumberDropDownInfo(@Body() req:TabNameReq): Promise<CommonResponse> {
          try {
            return await this.workOrderService.getBaleNumberDropDownInfo(req);
          } catch (error) {
            console.log(error)
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
          }
      }

          @Post('/getWONumberDropDownInfo')
            async getWONumberDropDownInfo(): Promise<CommonResponse> {
              try {
                return await this.workOrderService.getWONumberDropDownInfo();
              } catch (error) {
                console.log(error)
                return this.applicationExceptionHandler.returnException(CommonResponse, error);
              }
          }

@Post('/getWorkOrderInfo')
        async getWorkOrderInfo(@Body() req:WorkOrderInfoReq): Promise<CommonResponse> {
          try {
            return await this.workOrderService.getWorkOrderInfo(req);
          } catch (error) {
            console.log(error)
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
          }
      }
}